/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Faq_2_QInputs */

const en_cp_faq_2_q = /** @type {(inputs: Cp_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How do we grade individual contribution in a team?`)
};

const id_cp_faq_2_q = /** @type {(inputs: Cp_Faq_2_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana cara menilai kontribusi individu dalam tim?`)
};

/**
* | output |
* | --- |
* | "How do we grade individual contribution in a team?" |
*
* @param {Cp_Faq_2_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_faq_2_q = /** @type {((inputs?: Cp_Faq_2_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Faq_2_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_faq_2_q(inputs)
	return en_cp_faq_2_q(inputs)
});